import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {UIControllerType} from '../../../../react-oe/oe-types';
import OEResizeObserver from '../../../../lib/components/oe-resize-observer';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import OEAnimateHelper from '../../../../lib/animation/oe-animate-helper';
import retardUpdate from '../../../../lib/react/update-retarder';
import {CustomScrollbarTrackVisibility} from '../../../../lib/custom-scrollbar/custom-scrollbar';
import OEWidgetHeader from '../../../elements/oe-widget-header';
import {OEMediaCenterMode, OEMediaCenterModeBottomBarLayoutType, OEMediaCenterPropTypes, OEMediaCenterConfigFactory} from '../oe-media-center-model';
import OEMediaCenterCategoryController from './oe-media-center-category-controller';
import OEMediaCenterItemCollectionController from '../oe-media-center-item-collection-controller';
import {OEPresentationSlideMagnificationPlacement} from '../../presentation/oe-presentation-slide-magnification';
import {OEManualViewLinks} from '../../../views/manual-view/oe-manual-view-model';

export default class OEMediaCenterRightBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.size = {w: 0, h: 0};
        
        this.show = this.shouldShow();
        this.animateVisibility = false;

        this.edgeOffsets = this.determineEdgeOffsets(false);

        //
        this.state = Object.assign({
            style:          this.determineStyle(),
            innerStyle:     this.determineInnerStyle()
        });

        //
        this.lastEdgeOffsetsUpdateAnimated = false;

        //
        this.onResize = this.onResize.bind(this);

        this.onHelpBtnPressed = this.onHelpBtnPressed.bind(this);
    }

    getEdgeOffsets()    {
        return clone(this.edgeOffsets);
    }

    componentWillReceiveProps(nextProps) {

        retardUpdate(this, () => {

            if(nextProps.visible != this.props.visible || nextProps.config.bigPlayBtn != this.props.config.bigPlayBtn || nextProps.playMode != this.props.playMode || nextProps.config.mode != this.props.config.mode
                || nextProps.bottomBarModeLayoutType != this.props.bottomBarModeLayoutType || !OEToolbox.shallowEqual(nextProps.directPlay, this.props.directPlay))   {

                this.updateShow(true, nextProps);
            }

            if(!OEToolbox.shallowEqual(nextProps.edgeOffsets, this.props.edgeOffsets, true))    {
                this.updateStyle(nextProps);
            }
        });
    }

    shouldShow(props)   {
        props = props || this.props;
        
        if(!props.visible)  return false;
        
        if(props.config.mode === OEMediaCenterMode.bottomBar && props.bottomBarModeLayoutType == OEMediaCenterModeBottomBarLayoutType.vertical)  return true;

        if(!(props.config.bigPlayBtn && props.playMode) && !props.directPlay.enabled)    return true;

        return false;
    }

    determineEdgeOffsets(animated = true, props)   {
        props = props || this.props;
        return {
            right:      this.show ? this.size.w : 0,
            animate:    {right: animated}
        };
    }

    updateShow(animated = true, props)  {
        let show = this.shouldShow(props);
        if(show == this.show)   return;
        this.show = show;

        //
        props = props || this.props;
        this.animateVisibility = animated && this.props.bottomBarModeLayoutType === props.bottomBarModeLayoutType;
        
        //
        retardUpdate(this, () => {
            this.updateInnerStyle(props);
            this.updateEdgeOffsets(animated, props);
        });
    }

    updateEdgeOffsets(animated = true, props)  {
        props = props || this.props;

        let edgeOffsets = this.determineEdgeOffsets(animated, props);

        this.lastEdgeOffsetsUpdateAnimated = animated;

        if(OEToolbox.shallowEqual(edgeOffsets, this.edgeOffsets, true)) return;

        this.edgeOffsets = edgeOffsets;

        retardUpdate(this, () => {
            if(props.onEdgeOffsetsChanged)  props.onEdgeOffsetsChanged(edgeOffsets);
        });
    }

    determineStyle(props)   {
        props = props || this.props;
        return {
            right:          props.edgeOffsets ? props.edgeOffsets.right : undefined,
            bottom:         props.edgeOffsets ? props.edgeOffsets.bottom : undefined,
            transition:     props.edgeOffsets ? OEAnimateHelper.transitionForInsets(props.edgeOffsets.animate, 0.333, {right: true, bottom: true}) : ''
        };
    }

    updateStyle(props)  {
        this.setState({style: this.determineStyle(props)});
    }

    determineInnerStyle(props)   {
        return {
            transform:      'translateX(' + (!this.show ? '100%' : '0') + ')',
            transition:     this.animateVisibility ? 'transform 0.333s ease' : ''
        };
    }

    updateInnerStyle(props)  {
        this.setState({innerStyle: this.determineInnerStyle(props)});
    }

    onResize(sender, size)  {
        if(OEToolbox.shallowEqual(size, this.size, true))   return;
        let widthChanged = size.w != this.size.w;
        this.size = {w: size.w, h: size.h};

        retardUpdate(this, () => {
            if(widthChanged)    this.updateEdgeOffsets(this.lastEdgeOffsetsUpdateAnimated);
            if(this.props.onSizeChanged)    this.props.onSizeChanged(size);
        });
    }

    renderStdContent()  {
        return (
            <div className="std-content">
                <OEWidgetHeader
                    className="std-bg popover-control"
                    moduleId={this.props.moduleId}
                    buttonClassName="transparent-btn"
                    uiControllerType={UIControllerType.media_center}
                    onHelpBtnPressed={this.props.config.showHelpBtn ? this.onHelpBtnPressed : null}
                />

                <div className="body light-bg d-flex flex-column">

                    <OEMediaCenterCategoryController
                        moduleId={this.props.moduleId}
                        enabled={this.props.enabled}
                        hideIfNotNeeded={this.props.config.hideCategoryBarIfNotNeeded}
                    />
                    <OEMediaCenterItemCollectionController
                        className="flex-grow-1"
                        moduleId={this.props.moduleId}
                        config={{
                            usePresItems:       true,
                            presPlayableFlags:  this.props.config.presPlayableFlags
                        }}
                        enabled={this.props.enabled}
                        scrollbar={{
                            horizontalTrackVisiblity:       CustomScrollbarTrackVisibility.none,
                            verticalTrackVisiblity:         CustomScrollbarTrackVisibility.always,
                        }}
                        onSelected={this.props.onItemCollectionSelected}
                    />
                </div>
            </div>
        );
    }

    renderBottomBarModeContent()    {
        return (
            <div className="bottom-bar vertical-layout">
                <OEMediaCenterItemCollectionController
                    moduleId={this.props.moduleId}
                    className="vertical-layout"
                    config={{
                        usePresItems:       false,
                        presPlayableFlags:  this.props.config.presPlayableFlags
                    }}
                    magnification={this.props.config.presMagnification}
                    magnificationPlacement={OEPresentationSlideMagnificationPlacement.left}
                    enabled={this.props.enabled}
                    onSelected={this.props.onItemCollectionSelected}
                />
            </div>
        );
    }

    render() {
        return (
            <div
                className="right-bar"
                style={this.state.style}
            >
                <div
                    className="right-bar-inner"
                    style={this.state.innerStyle}
                >
                    <OEResizeObserver onResize={this.onResize}/>

                    {this.props.config.mode !== OEMediaCenterMode.bottomBar ? 
                        this.renderStdContent() : 
                        (this.props.bottomBarModeLayoutType === OEMediaCenterModeBottomBarLayoutType.vertical ? this.renderBottomBarModeContent() : null)
                    }

                </div>
            </div>
        );
    }

    onHelpBtnPressed()  {
        if(this.props.appComponent)    this.props.appComponent.uiLayer.manualView.setOpen(true, {link: OEManualViewLinks.mediaCenter});
    }
}

OEMediaCenterRightBar.defaultProps = {
    className:                  '',
    moduleId:                   '',
    config:                     OEMediaCenterConfigFactory.std(),
    visible:                    true,
    enabled:                    true,
    playMode:                   false,
    directPlay: {
        enabled:                false
    },
    bottomBarModeLayoutType:    OEMediaCenterModeBottomBarLayoutType.std
};

OEMediaCenterRightBar.propTypes = {
    className:                  PropTypes.string,
    moduleId:                   PropTypes.string,
    config:                     OEMediaCenterPropTypes.configDecl,
    visible:                    PropTypes.bool,
    enabled:                    PropTypes.bool,
    playMode:                   PropTypes.bool,
    directPlay: PropTypes.shape({
        enabled:                PropTypes.bool
    }),
    edgeOffsets:                OEAnimateHelper.offsetDecl,
    bottomBarModeLayoutType:    PropTypes.oneOf(OEMediaCenterModeBottomBarLayoutType.all),
    onSizeChanged:              PropTypes.func,
    onEdgeOffsetsChanged:       PropTypes.func,
    onItemCollectionSelected:   PropTypes.func
};